export default class PropertyService {
  static propertiesName = 'properties.json'

  static properties = {
    DI_HOST: '',
    DI_SUBSCRIPTION_KEY: '',
    DI_STATE_SINCE: '',
    AI_CONNECTION_STRING: '',
    AI_ENABLED: '',
    CSP_META: '',
    FRIENDLY_CAPTCHA_SITEKEY: '',
    TRACK_ENABLED: '',
    TRACK_ACCOUNTS: [''],
    TARIFF_CHANGE_CAMPAIGN_CODE: '',
    MOVE_IN_OPEN_CAMPAIGN_CODE: '',
    MOVE_IN_CLOSED_CAMPAIGN_CODE: '',
    MOVE_CAMPAIGN_CODE: '',
    CONTACT_FORM_PROCESS_SIGN: '',
    DASHBOARD_PROCESS_SIGN: '',
    MAX_TIME_DIFF: '',
    CHATBOT_URL: '',
    CHATBOT_SITE_ID: ''
  }

  static get diHost () {
    return this.properties.DI_HOST
  }

  static get diSubscriptionKey () {
    return this.properties.DI_SUBSCRIPTION_KEY
  }

  static get diStateSince () {
    return this.properties.DI_STATE_SINCE
  }

  static get aiConnectionString () {
    return this.properties.AI_CONNECTION_STRING
  }

  static get aiEnabled () {
    return this.properties.AI_ENABLED
  }

  static get friendlyCaptchaSitekey () {
    return this.properties.FRIENDLY_CAPTCHA_SITEKEY
  }

  static get trackEnabled () {
    return this.properties.TRACK_ENABLED
  }

  static get trackAccounts () {
    return this.properties.TRACK_ACCOUNTS
  }

  static get tariffChangeCampaignCode () {
    return this.properties.TARIFF_CHANGE_CAMPAIGN_CODE
  }

  static get moveInOpenCampaignCode () {
    return this.properties.MOVE_IN_OPEN_CAMPAIGN_CODE
  }

  static get moveInClosedCampaignCode () {
    return this.properties.MOVE_IN_CLOSED_CAMPAIGN_CODE
  }

  static get moveCampaignCode () {
    return this.properties.MOVE_CAMPAIGN_CODE
  }

  static get contactFormProcessSign () {
    return this.properties.CONTACT_FORM_PROCESS_SIGN
  }

  static get dashboardProcessSign () {
    return this.properties.DASHBOARD_PROCESS_SIGN
  }

  static get CSPMetaTag () {
    return this.properties.CSP_META
  }

  static get chatbotUrl () {
    return this.properties.CHATBOT_URL
  }

  static get chatbotSiteId () {
    return this.properties.CHATBOT_SITE_ID
  }

  static get maxTimeDiff () {
    const value = this.properties.MAX_TIME_DIFF * 1000
    const oneHour = 1 * 60 * 60 * 1000
    return value || oneHour
  }

  static isPrd () {
    const host = window.location.host
    const hostCso = 'service.vattenfall.de'
    const hostVfde = 'vattenfall.de'
    return [hostCso, hostVfde].includes(host)
  }

  static isAcc () {
    const host = window.location.host
    const hostCso = 'service-acc.vattenfall.de'
    return [hostCso].includes(host)
  }

  static getPropertiesUrl () {
    const propertiesName = PropertyService.propertiesName
    const now = Date.now()
    return `/${propertiesName}?timestamp=${now}`
  }

  static async getProperties (callback) {
    try {
      const response = await fetch(this.getPropertiesUrl())
      const properties = await response.json()
      if (this.isPrd() && properties.DI_STATE_SINCE) {
        properties.DI_STATE_SINCE = ''
      }
      this.properties = properties
    } finally {
      callback()
    }
  }
}
